<template>
    <div class="invoice-modal">
        <div class="modal-body">
            <!-- 发票类型 -->
            <div class="invoice-type">
                <div class="label">发票类型</div>
                <div class="radio-group">
                    <el-radio v-model="invoiceForm.invoiceType" label="普通发票">普通发票</el-radio>
                </div>
            </div>

            <!-- 发票信息 -->
            <div class="invoice-info">
                <div class="section-title">发票信息</div>

                <!-- 抬头类型 -->
                <div class="form-item-1">
                    <div class="label">抬头类型</div>
                    <div class="radio-group">
                        <el-radio v-model="invoiceForm.titleType" label="个人"
                            @change="handleTitleTypeChange">个人</el-radio>
                        <el-radio v-model="invoiceForm.titleType" label="企业"
                            @change="handleTitleTypeChange">企业</el-radio>
                    </div>
                </div>

                <!-- 发票抬头和公司税号 -->
                <div class="form-row">
                    <div class="form-item flex-1">
                        <div class="label">发票抬头<span class="required">*</span></div>
                        <el-input v-model="invoiceForm.title" placeholder="发票抬头不能为空" :validate-event="false"
                            class="form-input" />
                    </div>
                    <div class="form-item flex-1" v-if="invoiceForm.titleType === '企业'">
                        <div class="label">公司税号<span class="required">*</span></div>
                        <el-input v-model="invoiceForm.taxNumber" placeholder="企业单位税号不能为空" :validate-event="false"
                            class="form-input" />
                    </div>
                </div>

                <!-- 抬头类型和商品明细 -->
                <div class="form-row">
                    <div class="form-item flex-1">
                        <div class="label">抬头类型</div>
                        <el-select v-model="invoiceForm.titleDetailType" placeholder="请选择" class="form-input">
                            <el-option label="商品明细" value="商品明细"></el-option>
                        </el-select>
                    </div>
                </div>

                <!-- 联系方式和电子邮箱 -->
                <div class="form-row">
                    <div class="form-item flex-1">
                        <div class="label">联系方式<span class="required">*</span></div>
                        <el-input v-model="invoiceForm.contact" placeholder="请输入" :validate-event="false" maxLength="11"
                            class="form-input" />
                    </div>
                    <div class="form-item flex-1">
                        <div class="label">电子邮箱<span class="required">*</span></div>
                        <el-input v-model="invoiceForm.email" placeholder="电子邮箱不能为空" :validate-event="false"
                            class="form-input" />
                    </div>
                </div>

                <!-- 设置为默认抬头 -->
                <div class="form-item">
                    <div class="label">设置为默认抬头</div>
                    <el-switch v-model="invoiceForm.isDefault" active-color="#1890ff" style="margin-left: 12px;" />
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <el-button type="primary" class="save-btn" @click="saveInvoice">{{ isEdit ? '编辑' : '保存' }}</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewFapiao',
    data() {
        return {
            invoiceForm: {
                invoiceType: '普通发票',
                titleType: '个人',
                title: '',
                taxNumber: '',
                titleDetailType: '商品明细',
                contact: '',
                email: '',
                isDefault: true
            }
        }
    },
    props: {
        address: {
            type: Object,
            default: () => { }
        },
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        address: {
            handler(newVal, oldVal) {
                console.log('address变化了:', newVal);
                if (newVal && Object.keys(newVal).length > 0) {
                    // 将监听到的address数据映射到addressForm中
                    this.aid = newVal.aid || ''

                    this.invoiceForm = {
                        // 映射现有数据到表单字段
                        title: newVal.username || '',
                        taxNumber: newVal.tax_number || '',
                        contact: newVal.mobile || '',
                        email: newVal.email || '',
                        isDefault: newVal.is_default == 1 ? true : false,
                        titleType: newVal.type == 1 ? '个人' : '企业',
                        titleDetailType: '商品明细',
                        invoiceType: '普通发票',
                    };

                } else {
                    // 当address为空对象时，重置表单
                    this.resetForm();
                    this.aid = ''; // 重置aid变量
                }
            },
            deep: true,
            immediate: true // 添加immediate选项，确保组件初始化时也能执行
        }
    },
    methods: {
        // 处理抬头类型切换
        handleTitleTypeChange() {
            if (this.invoiceForm.titleType === '个人') {
                this.invoiceForm.taxNumber = '';
            }
        },
        // 保存发票抬头
        saveInvoice() {
            // 表单验证
            if (!this.invoiceForm.title) {
                this.$message.error('发票抬头不能为空');
                return;
            }
            if (this.invoiceForm.titleType === '企业' && !this.invoiceForm.taxNumber) {
                this.$message.error('公司税号不能为空');
                return;
            }
            if (!this.invoiceForm.contact) {
                this.$message.error('联系方式不能为空');
                return;
            }
            if (!this.invoiceForm.email) {
                this.$message.error('电子邮箱不能为空');
                return;
            }
            let data = {
                aid: this.aid,
                username: this.invoiceForm.title,
                tax_number: this.invoiceForm.taxNumber,
                mobile: this.invoiceForm.contact,
                email: this.invoiceForm.email,
                type: this.invoiceForm.titleType === '个人' ? 1 : 2,
                is_default: this.invoiceForm.isDefault ? 1 : 0
            }
            // 保存逻辑
            // console.log('保存发票抬头:', data);
            // return
            // 提交数据到后端
            if (this.isEdit) {
                this.$dapi.editFapiaoFn(data).then(res => {
                    this.$message.success('编辑发票成功');
                    // 发射事件通知父组件
                    this.$emit('fapiaoAdded');
                    this.resetForm()
                    this.closeModal();

                }).catch(err => {
                    this.$message.error(err);
                })
            } else {
                this.$dapi.newFapiaoFn(data).then(res => {
                    this.$message.success('新增发票成功');
                    // 发射事件通知父组件
                    this.$emit('fapiaoAdded');
                    this.resetForm()
                    this.closeModal();

                }).catch(err => {
                    this.$message.error(err);
                })
            }
        },

        resetForm() {
            this.aid = ''; // 重置aid变量
            this.invoiceForm = {
                invoiceType: '普通发票',
                titleType: '个人',
                title: '',
                taxNumber: '',
                titleDetailType: '商品明细',
                contact: '',
                email: '',
                isDefault: true
            }
        },
        // 关闭弹窗
        closeModal() {
            // 关闭逻辑
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.invoice-modal {
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid #ebeef5;
}

.modal-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.close-btn {
    font-size: 24px;
    color: #909399;
    cursor: pointer;
    line-height: 1;
}

.close-btn:hover {
    color: #606266;
}

.modal-body {
    padding: 24px;
}

.invoice-type {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    text-align: left;
}

.section-title {
    margin-bottom: 16px;
    text-align: left;
    font-weight: bold;
    font-size: 16px;
    color: #333333;

}

.form-item-1 {
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
}

.form-item {
    margin-bottom: 20px;
    text-align: left;
    /* display: flex;
    align-items: center; */
}

.form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.flex-1 {
    flex: 1;
}

.label {
    font-size: 14px;
    color: #303133;
    margin-bottom: 8px;
    display: inline-block;
}

.required {
    color: #f56c6c;
    margin-left: 4px;
}

.radio-group {
    display: flex;
    gap: 20px;
    margin-left: 40px;
}

.form-input {
    width: 100%;
}

.modal-footer {
    padding: 12px 24px;
    border-top: 1px solid #ebeef5;
    text-align: center;
}

.save-btn {
    width: 120px;
    height: 40px;
    border-radius: 4px;
}
</style>